import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import MarkerMaps from './MarkerMaps';
import MapLegend from './MapLegend';
import UsgsTable from './UsgsTable';
import RegionHeader from './RegionHeader';
import Error from './Error';
import ColorsContext from './ColorsContext';
import { getDefaultDate, setLongmonyr } from './routines';

function UsgsRegion(props) {
	const monyr = props.date ? props.date : getDefaultDate();
	const areaType = props.areaType;
	const { sfgw="sf" } = props;
	
	const [ markers, setMarkers ] = useState(null);
	const [ regionData, setRegionData ] = useState(null);
	const [ regionError, setRegionError ] = useState(false);
	const [ regionColors, setRegionColors ] = useState([]);
	const { levelColors, pctlColors } = useContext(ColorsContext);

	const selectedState = "ma"
	const ptDataFileNameBase = areaType === "region" ? "station_" : `station_${areaType}_`;
	const ptDataFileName = (window.location.hostname === "localhost" ? "." : "/ma") + "/data/" + ptDataFileNameBase + sfgw + "_" + monyr + ".json";
	const rgDataFileNameBase = areaType === "region" ? "regional_" : `${areaType}_`;
    const rgDataFileName = (window.location.hostname === "localhost" ? "." : "/ma") + "/data/" + rgDataFileNameBase + sfgw + "_" + monyr + ".json";
	const sfgwTitle = sfgw === 'gw' ? "Groundwater" : "Streamflow";
	const sfgwPeriod = sfgw === 'gw' ? "" : "30-Day";
	const longmonyr = setLongmonyr(monyr);
	const mapInfoMoreText = sfgw === 'gw' ? "Circles are continuous and squares are periodic reporting wells." : null;

	const buttonValue = sfgw + "" + (monyr.length === 7 ? (areaType === 'region' ? "station" : `${areaType}station`) : (areaType === 'region' ? "wkstation" : `wk${areaType}station`));
	const addtext = () => {
		if (monyr.length > 7) {
			return sfgw === 'gw'
				? "These data are updated weekly for real-time data-transmission wells. The values reflect the measurements taken near the date indicated on the map. Data may be provisional."
				: "These data are updated weekly. The values reflect the median daily value over the 30 days ending on the date indicated on the map. Data may be provisional."
		} else {
			return "Data may be provisional."
		}
	};
	
	const other_geodata = require(areaType === 'basin' ? './geo/majorBasins_geo.json' : './geo/MAcounties_geo.json');

	const getPointData = () => {
		let allmarkers = [];
		axios.get(ptDataFileName)
		.then(results => {
			Object.keys(results.data.data).forEach(region => {
				Object.keys(results.data.data[region]).forEach(sky => {
					const stn = results.data.data[region][sky]
					const val = stn.pctl
					let fcolor = 9
					pctlColors.some((e, i) => {
						fcolor = e.color
						return val > e.range[0] && val <= e.range[1]
					})
					allmarkers.push({
						position: stn.position, 
						fillColor: fcolor, 
						icon: stn.station_type === "periodic" ? "square" : "circle",
						iconsize: 5, //Math.min(9, Math.trunc((stn.count)/10 + 2)),
						data: [stn.name, "Percentile: " + val + (stn.mdate ? (" on " + stn.mdate) : "")]
					});
				});
			});
			setMarkers(allmarkers);
		})
		.catch(err => {
			console.log("Point Data Error: " + err);
			setRegionError(true);
		});
	}

	const getRegionData = () => {
		axios.get(rgDataFileName)
		.then(results => {
			setRegionData(results.data.data);
			let allRegions = [];
			Object.keys(results.data.data).forEach(region => {
				const zone = results.data.data[region].zone
				allRegions[zone] = levelColors.plain;
			});
			setRegionColors(allRegions);
		})
		.catch(err => {
			console.log("Region Data Error: " + err);
			setRegionError(true);
		});
	}

	useEffect(() => {
		getPointData();
		getRegionData();
		setRegionError(false);
		 // eslint-disable-next-line
	}, [])

	return (
		<>
			{!regionError &&
				<RegionHeader
					title={sfgwTitle+" Summary"}
					buttontext={"Table View"}
					addtext={addtext()}
					buttonValue={buttonValue}
					handleButtonClick={props.handleButtonClick}
				/>
			}
			{markers &&
				<div className="mapandlegend-container">
					<MarkerMaps 
						selectedState={selectedState} 
						markers={markers} 
						regionColors={regionColors}
						mapTitle={longmonyr + " " + (longmonyr.search(",") < 0 ? "" : sfgwPeriod) + " " + sfgwTitle + " Percentiles"}
						geo={areaType === 'region' ? "drought" : other_geodata}
						mapInfoMoreText={mapInfoMoreText}
					/>
					<MapLegend 
						title={"Point Values - " + sfgwTitle + " Percentiles"}
					/>
				</div>
			}

			{regionData &&
				<>
					<UsgsTable
						regionData={regionData}
						monyr={longmonyr}
						sfgw={sfgw}
						areaType={areaType}
					/>
				</>
			}
			{regionError &&
				<>
					<Error />
				</>
			}
	   </>
	);
}

export default UsgsRegion;

//in MapLegend -- footer="A larger symbol reflects a longer period of record."